import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { AssetSvg } from "../../../assets";
import { Modals } from "../../../configs";
import { BootstrapUtils } from "../../../utils";
type Props = {
  handleShow: (value: boolean) => void;
};
export function AddParticipantButton(props:Props) {
  return (

      <button

        className="btn btn-opaque conference-control-btn"
        data-toggle="modal"
        aria-pressed="false"
        data-target={BootstrapUtils.GetSelectorById(Modals.AddParticipant)}
          onClick={() => props.handleShow(true)}
      >
        <AssetSvg.AddParticipant /></button>

  );
}
